module.exports = __webpack_public_path__ + "img/shape-octagon.40bf4f53.svg";